import Vue from 'vue'
import moment from 'moment';
import { NotifBatch, NotifFilter, NotifGap,NotifGapBatch, NotifProvider } from './types';

export default {
    namespaced: true,
    actions: {
        async getList({ rootState }, filter: NotifFilter) {
            // SET FORM DATA
            const params = new FormData();
            const entityId: string = rootState.auth.entityId;
            if (entityId) {
                params.append('entityId', entityId);
            }
            params.append('messageType', filter.messageType);
            params.append('toPhone', filter.toPhone.replace(/\D/g, ''));
            params.append('recordDateFrom', moment(filter.recordDateFrom).format("YYYY-MM-DD"));
            params.append('recordDateTo', moment(filter.recordDateTo).format("YYYY-MM-DD"));
            // GET LIST ASYNC
            const { data } = await Vue.axios.post('gaps/notif/list', params);
            //
            return data;
        },
        async getGaps({ commit }, { batchId, toPhone }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('batchId', batchId);
            params.append('toPhone', toPhone.replace(/\D/g, ''));
            // GET GAPS ASYNC
            const { data } = await Vue.axios.post('gaps/notif/gap/list', params);
            //
            return data;
        },
        async getProviders({ commit }, { batchId, toPhone }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('batchId', batchId);
            params.append('toPhone', toPhone.replace(/\D/g, ''));
            // GET GAPS ASYNC
            const { data } = await Vue.axios.post('gaps/notif/provider/list', params);
            //
            return data;
        },
        async getGapSMS({ commit }, publicId: string) {
            // SET FORM DATA
            const params = new FormData();
            params.append('publicId', publicId);
            // GET SMS ASYNC
            const { data } = await Vue.axios.post('gaps/notif/gap/sms', params)
            //
            return data;
        },
        async saveBatch({ rootState }, batch: NotifBatch) {
            // SET FORM PARAMETERS
            const params = new FormData();
            params.append('entityId', rootState.auth.entityId);
            params.append('campaignId', batch.campaignId);
            params.append('messageType', batch.messageType);
            params.append('description', batch.description);
            if (batch.templateId) {
                params.append('templateId', batch.templateId);
            }
            if (batch.providerTemplateId) {
                params.append('providerTemplateId', batch.providerTemplateId);
            }
            // SAVE BATCH ASYNC
            const { data } = await Vue.axios.post('gaps/notif/save', params);
            //
            return data;
        },
        async saveGap({ commit }, gap: NotifGap) {
            // SET FORM PARAMETERS
            const params = new FormData();
            params.append('batchId', String(gap.batchId));
            params.append('gapId', String(gap.gapId));
            params.append('toPhone', gap.toPhone);
            // SAVE NOTIF GAP ASYNC
            const { data } = await Vue.axios.post('gaps/notif/gap/save', params);
            //
            return data;
        },
        async saveGapBatch({ commit }, notif: NotifGapBatch) {
            // SET FORM PARAMETERS
            const params = new FormData();
            params.append('batchId', String(notif.batchId));
            params.append('gaps', JSON.stringify(notif.gaps));
            // SAVE NOTIF GAP ASYNC
            const { data } = await Vue.axios.post('gaps/notif/gap/save/batch', params);
            //
            return data;
        },
        async saveGapSMSResponse({ commit }, { publicId, text, comment }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('publicId', publicId);
            params.append('responseText', text);
            if(comment)
             params.append('comment', comment);
            // SAVE RESPONSE ASYNC
            const { data } = await Vue.axios.post('gaps/notif/gap/sms/answer', params)
            //
            return data;
        },
         async saveGapSMSComment({ commit }, { publicId, text }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('publicId', publicId);
            params.append('comment', text);
            // SAVE RESPONSE ASYNC
            const { data } = await Vue.axios.post('gaps/notif/gap/sms/comment', params)
            //
            return data;
        },
        async getGapVoicePreviewStream({ commit }, { gapId, templateId }) {
            // SET FORM PARAMS
            const params = new FormData();
            params.append('gapId', gapId);
            params.append('templateId', templateId);
            // GET STREAM ASYNC
            const { data } = await Vue.axios.post('gaps/notif/gap/voice/preview/stream',
                params, { responseType: "blob" })
            //
            return data;
        },
        async getGapVoicePreviewCall({ commit }, { gapId, templateId, phone }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('gapId', gapId);
            params.append('templateId', templateId);
            params.append('phone', phone);
            // GET CALL ASYNC
            const { data } = await Vue.axios.post('gaps/notif/gap/voice/preview/call', params)
            //
            return data;
        },
        async startConferenceCall({ commit }, { gapId, phone }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('gapId', gapId);
            params.append('phone', phone);
            // START CALL ASYNC: LET THE ERROR REACH THE CALLER SO IT CAN BE SHOWN
            const { data } = await Vue.axios.post('gaps/notif/gap/conference/start', params)
            //
            return data;
        },
        async getConferenceConfig({ commit }, { gapId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('gapId', gapId);
            // THE OFFICE'S CONFERENCE CALL SETTINGS: RECORDING ON OR OFF
            const { data } = await Vue.axios.post('gaps/notif/gap/conference/config', params)
            //
            return data;
        },
        async getGapVoicePreviewText({ commit }, { gapId, templateId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('gapId', gapId);
            params.append('templateId', templateId);
            // GET SMS ASYNC
            const { data } = await Vue.axios.post('gaps/notif/gap/voice/preview/text', params)
            //
            return data;
        },
        async getGapSMSPreview({ commit }, { gapId, templateId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('gapId', gapId);
            params.append('templateId', templateId);
            // GET SMS ASYNC
            const { data } = await Vue.axios.post('gaps/notif/gap/sms/preview', params)
            //
            return data;
        },
        async saveProvider({ commit }, provider: NotifProvider) {
            // SET FORM PARAMETERS
            const params = new FormData();
            params.append('batchId', String(provider.batchId));
            params.append('providerId', String(provider.providerId));
            params.append('minReferenceDate', String(provider.minReferenceDate));
            params.append('maxReferenceDate', String(provider.maxReferenceDate));
            params.append('gaps', String(provider.gaps));
            params.append('patients', String(provider.patients));
            params.append('toPhone', provider.toPhone);
            // SAVE NOTIF PROVIDER ASYNC
            const { data } = await Vue.axios.post('gaps/notif/provider/save', params);
            //
            return data;
        },
        async getProviderVoicePreviewText({ commit }, { provider, templateId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('providerId', provider.id);
            params.append('minReferenceDate', String(provider.minReferenceDate));
            params.append('maxReferenceDate', String(provider.maxReferenceDate));
            params.append('gaps', String(provider.gaps));
            params.append('patients', String(provider.patients));
            params.append('templateId', templateId);
            // GET SMS ASYNC
            const { data } = await Vue.axios.post('gaps/notif/provider/voice/preview/text', params)
            //
            return data;
        },
        async getProviderVoicePreviewStream({ commit }, { provider, templateId }) {
            // SET FORM PARAMS
            const params = new FormData();
            params.append('providerId', provider.id);
            params.append('minReferenceDate', String(provider.minReferenceDate));
            params.append('maxReferenceDate', String(provider.maxReferenceDate));
            params.append('gaps', String(provider.gaps));
            params.append('patients', String(provider.patients));
            params.append('templateId', templateId);
            // GET STREAM ASYNC
            const { data } = await Vue.axios.post('gaps/notif/provider/voice/preview/stream',
                params, { responseType: "blob" })
            //
            return data;
        },
        async getProviderVoicePreviewCall({ commit }, { provider, templateId, phone }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('providerId', provider.id);
            params.append('minReferenceDate', String(provider.minReferenceDate));
            params.append('maxReferenceDate', String(provider.maxReferenceDate));
            params.append('gaps', String(provider.gaps));
            params.append('patients', String(provider.patients));
            params.append('templateId', templateId);
            params.append('phone', phone);
            // GET CALL ASYNC
            const { data } = await Vue.axios.post('gaps/notif/provider/voice/preview/call', params)
            //
            return data;
        },
        async getProviderSMSPreview({ commit }, { provider, templateId }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('providerId', provider.id);
            params.append('minReferenceDate', String(provider.minReferenceDate));
            params.append('maxReferenceDate', String(provider.maxReferenceDate));
            params.append('gaps', String(provider.gaps));
            params.append('patients', String(provider.patients));
            params.append('templateId', templateId);
            // GET SMS ASYNC
            const { data } = await Vue.axios.post('gaps/notif/provider/sms/preview', params)
            //
            return data;
        }
    }
}
